import React from 'react'


import __t from "../../../lib/traduzioni";
import useBSSLogger from '../../../hooks/useBSSLogger';
import { Popper } from '@mui/material';
import { useContext } from 'react';
import StatoComparatoreContext from './contexts/StatoComparatore';
import { useRef } from 'react';
import { useState } from 'react';
import { makeStyles } from '@mui/styles';

const {logger} = useBSSLogger();

const useStyles = makeStyles((theme) => {
    return {
        arrow: {
            position: 'absolute',
            fontSize: 7,
            width: '3em',
            height: '3em',
            '&::before': {
                content: '""',
                margin: 'auto',
                display: 'block',
                width: 0,
                height: 0,
                borderStyle: 'solid',
            },
        },
    }
})


const PopperAddizionale = () => {

    const classes = useStyles();
    const [arrowRef, setArrowRef] = useState(null);
    const {statoPopperAddizionale} = useContext(StatoComparatoreContext)
    const {open, anchorEl, bgcolor, title} = statoPopperAddizionale;
    const modifiers = [
        //non funziona sembra https://github.com/mui/material-ui/issues/27301
        // {
        //     name: "arrow",
        //     enabled: true,
        //     options: {
        //         element: arrowRef
        //     }
        // }
    ]

    return (
        <Popper 
            disablePortal={true} 
            open={open} 
            anchorEl={anchorEl}
            modifiers={modifiers}    
        >
            {/* <span ref={setArrowRef} className={classes.arrow} /> */}
            <div style={{color: bgcolor, backgroundColor: "white"}}>
                {title}
            </div> 
        </Popper> 
    )
}

export default PopperAddizionale;